import { render, staticRenderFns } from "./SortIcons.vue?vue&type=template&id=449a62af&scoped=true&"
import script from "./SortIcons.vue?vue&type=script&lang=js&"
export * from "./SortIcons.vue?vue&type=script&lang=js&"
import style0 from "./SortIcons.vue?vue&type=style&index=0&id=449a62af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a62af",
  null
  
)

export default component.exports